const reader = (file, type) => {

    if (type !== 'csv' && type !== 'xlsx')
        return

    const fileReader = new FileReader()
    
    fileReader.readAsArrayBuffer(file)

    return new Promise((resolve, reject) => {
        fileReader.onload = (ev) => {
            const bufferData = ev.target.result
            resolve(bufferData)
        }

        fileReader.onerror = (error) => reject(error)
    })
}

export default reader